/**
 * Guess Internet Explorer version.
 *
 * @returns {Number|boolean} IE version or false.
 */
S.ie = function ()
{
    const
        ua = window.navigator.userAgent,
        msie = ua.indexOf('MSIE ');

    // IE 10 or older => return version number
    if (msie > 0)
    {
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    // IE 11 => return version number
    const trident = ua.indexOf('Trident/');

    if (trident > 0)
    {
        const rv = ua.indexOf('rv:');

        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    // IE 12 => return version number
    const edge = ua.indexOf('Edge/');

    if (edge > 0)
    {
        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }

    return false;
};
